module.exports = {
  btn: {
    btn1: 'Confirm',
    btn2: 'Cancel',
    btn3: 'Withdrawal',
    btn4: 'Finish',
    btn5: 'Example',
    btn6: 'Trial',
    btn7: 'Return',
    btn8: 'Withdraw Now',
    btn9: 'I see',
    btn10: 'Withdraw and cancel'
  },
  label: {
    label0: 'Smart Deposit Plan  Sale Hot',
    label1: 'The Convenience of Demand Deposits The Income of Time Deposits',
    label2: 'Deposit',
    label3: 'Out of Service Hours.',
    label4: 'Trading hours are 0:00-21:00 daily.',
    label5: 'Easy savings with small change',
    label6: 'Half-year / one-year entertainment plan',
    label7: 'Prepare a birthday surprise for my dear',
    label8: 'Save your salary easily and worry-free',
    label9: 'Please login first.',
    label10: 'Save a small amount of change  get a large pile of money',
    label11: 'Balance automatically transferred in to make you enjoy benefits easily',
    label12: 'Dividends paid on a regular basis',
    label13: 'Interest accrues on the same day',
    label14: 'Save your effort',
    label15: 'Add a New Plan',
    label16: 'Plan Annual Entertainment As Early As Possible',
    label17: 'Get Ready For a Sweet Trip',
    label18: '',
    label19: 'The New Bag is Really Nice',
    label20: '',
    label21: 'Save Money For Your Hobby',
    label22: '',
    label23: 'It\'s great to save wealth automatically every month',
    label24: 'Wages are deposited automatically ',
    label25: 'when they arrive at the account',
    label26: 'Benefit from an ',
    label27: 'active pay raise',
    label28: 'Birthday/holiday is around the corner',
    label29: 'It\'s only 100 days from my love\'s birthday. I don\'t have enough gift funds',
    label30: 'Don\'t worry, smart deposit will help you',
    label31: 'Monthly Deposit',
    label32: 'Demand Deposit',
    label33: 'MONTHLY UP',
    label34: 'DAY DAY GOLD',
    label35: 'FIXED PRODUCT',
    label36: 'Save Money Every Month',
    label37: 'Keep Saving Change',
    label38: 'Interest Rate Depends On the Number of Deposit Months',
    label39: 'Interest Rate Depends On the Number of Deposit Days',
    label40: 'Save Money Regularly',
    label41: 'My',
    label42: 'Below 20k',
    label43: '20k (including 20k) ~ 1 M',
    label44: 'More than 1M(including 1M)',
    label45: '0-100k',
    label46: '100-200k',
    label47: '200-500k',
    label48: 'More than 500k (including 500k)',
    label49: '200k-1M',
    label50: '100k-500k',
    label51: 'Deposit Period',
    label52: 'Deposit',
    label53: 'Records',
    label54: 'Total position',
    label55: 'Cumulative income ',
    label56: '',
    label57: 'types of deposits',
    label58: 'Purchasing Amount',
    label59: 'Predictable Value Maturity',
    label60: 'Deposit period of ',
    label61: ' has been deposited for ',
    label62: ' days and expires on ',
    label63: '',
    label64: 'Expected due amount',
    label65: 'term',
    label66: 'Interest Rate',
    label67: 'Purchase Currency',
    label68: 'Purchase Account',
    label69: 'Due deposit account',
    label70: 'Deposit term',
    label71: 'Deposit interest rate',
    label72: 'months',
    label73: 'Transaction records',
    label74: 'Warm tips: This product only supports full withdrawal in advance',
    label75: 'Warm tips: Early withdrawal of current products can be partially or completely withdrawn.',
    label76: 'If you need to terminate this product, you need to cancel the contract.',
    label77: 'Early withdrawal',
    label78: 'Cancel the contract',
    label79: 'Warm tips: This product only supports full withdrawal in advance',
    label80: 'Warm tips: This product only supports full withdrawal in advance',
    label81: 'Warm tips: This product only supports full withdrawal in advance',
    label82: 'Excerpt',
    label83: 'Reset',
    label84: 'Transaction Product',
    label85: 'All Objects',
    label86: 'Demand Deposit',
    label87: 'FIXED PRODUCT',
    label88: 'DAY DAY GOLD',
    label89: 'Monthly Deposit',
    label90: 'MONTHLY UP',
    label91: 'Transaction Type',
    label92: 'Purchase',
    label93: 'All Transactions',
    label94: 'Redemption',
    label95: 'Withdrawal',
    label96: 'Contribution',
    label97: 'Dividend',
    label98: 'Purchase Currency',
    label99: 'Deposit Term',
    label100: 'Purchase Account',
    label101: 'Amount Deposited',
    label102: 'Minimum Purchase Amount {0}',
    label103: 'Please Select a Purchase Account',
    label104: 'Deposit All',
    label105: 'The current available balance of the account',
    label106: 'I have read the terms of this ',
    label107: 'Retained Amount',
    label108: 'Signed Account',
    label109: 'Dividend Frequency',
    label110: 'Contribution amount',
    label111: 'Contribution account',
    label112: 'Information confirmation',
    label113: 'Transaction failed, please check',
    label114: 'Deposit Succeeded',
    label115: 'Application Submitted',
    label116: 'Value Today',
    label117: 'At Maturity',
    label118: 'Withdrawal failed, please check',
    label119: 'Withdrawal successful',
    label120: 'principal',
    label121: 'interest',
    label122: 'Interest Accrual Rule',
    label123: '',
    label124: 'Deposit starting at {0} yuan, within the deposit period. The interest is calculated according to the number of deposit months and the deposit amount, and the principal is deposited in a lump sum, which supports all early withdrawals.',
    label125: 'Interest shall be calculated and paid according to the product interest rate published on the app product page of our bank on the day of deposit',
    label126: 'All withdrawals can be made in advance. When the deposit is enough for one month, the corresponding interest will be calculated. If there is not enough for the next month, there is no interest.',
    label127: 'Revenue Calculator',
    label128: 'Select Currency',
    label129: 'Select Term',
    label130: 'Drag the slider to select the amount you want to deposit',
    label131: 'Expected Income Available at Maturity',
    label132: 'Open Your Deposit Plan',
    label133: 'Purchase',
    label134: 'Maturity Date',
    label135: 'If the customer deposits MOP100,000, 3+2+1 months, withdraw at maturity, the deposit period expires 6 months, the interest is MOP100,000* ({0}/365*3 actual days in months +{1}/365*2 Actual number of days in a month +{2}/365* Actual number of days in a month)',
    label136: 'The deposit of current products starts at {0} MOP, and the retention amount of the contracted current account is set. When the end-of-day account balance is greater than the retained amount, the greater part is deposited into GRADED INTEREST DEPOSIT; when the end-of-day account balance is less than the retained amount, the less part is returned from the GRADED INTEREST DEPOSIT to the current account. Support all or partial withdrawal of principal and interest.',
    label137: 'Interest shall be calculated and paid according to the product interest rate published on the app product page of our bank on the day of deposit.',
    label138: 'For example, a customer has purchased and signed a daily deposit product of 10,000 MOP currency. ',
    label139: 'Average daily balance is 0~100,000, annual interest rate is {0}%; average daily balance is 100,000~200,000, annual interest rate is {1}%; ',
    label140: 'Average daily balance is 200,000~500,000, annual interest rate is {0}%; average daily balance is 500,000 and above, The annual interest rate is {1}%.',
    label141: 'For example, a customer purchases and signs a contract with a fixed term product of 10,000 MOP currency, the deposit period is 3 months, and the highest interest rate is {0}%',
    label142: 'Time Deposit',
    label143: 'The deposit starts at {0} MOP, the deposit period is agreed upon when depositing, and the principal is deposited in one lump sum to support all different early withdrawals.',
    label144: 'Interest shall be calculated and paid according to the product interest rate published on the app product page of our bank on the day of deposit; all withdrawals can be made in advance, and no interest will be paid in advance.',
    label145: 'The early withdrawal part is calculated according to the interest rate of our bank\'s early withdrawal on the day of withdrawal',
    label146: '{0} yuan minimum deposit, within the deposit term according to the number of days of deposit by the file interest, according to the fixed number of days of dividends, a lump sum deposit of the principal, support all withdrawal of the principal and interest in advance',
    label147: 'Interest shall be calculated and paid according to the product interest rate published on the app product page of our bank on the day of deposit.',
    label148: 'The withdrawal amount can be withdrawn in advance, and the interest rate of the product shall be calculated on file according to the number of days of deposit',
    label149: 'Dividend Payout Rules',
    label150: 'The deposit period is 50 days and the dividend is paid every 15 days;',
    label151: 'The deposit period is 100 days and the dividend is paid every 30 days;',
    label152: 'The deposit period is 160 days and the dividend is paid every 50 days.',
    label153: 'The interest of 160 daily interest deposits will be calculated in three stages: 1) the first stage is from the first to 100 days from the opening date of deposit; the second stage is from the 101 to 150 days from the opening date of deposit; the third stage is from 151 days to the maturity date of deposit. 2) The deposit interest is paid every 50 days.',
    label154: '{0} yuan minimum deposit, monthly contribution amount is not less than 500 yuan, deposit period is agreed, deduction is made on the 1st of each month, the principal and interest will be returned automatically upon maturity, and all withdrawal in advance is supported.',
    label155: 'Interest shall be calculated and paid according to the product interest rate published on the app product page of our bank on the day of deposit;',
    label156: 'all withdrawals can be made in advance, and no interest will be paid in advance.',
    label157: '1.Interest is calculated on the basis of 360 days per year and 30 days per month',
    label158: '2.The interest is calculated according to the actual deposit period of the deposit amount, the equation is the account opening amount * the daily interest rate * the actual deposit days + the first contribution amount * the daily interest rate * the actual deposit days + the second period contribution amount * the daily interest rate * the actual deposit days + +Contribution amount of the 12th installment * daily interest rate * actual deposit days',
    label159: 'max',
    label160: 'MOP',
    label161: 'CNY',
    label162: 'HKD',
    label163: 'USD',
    label164: 'CAD',
    label165: 'GBP',
    label166: 'AUD',
    label167: 'Deposit amount',
    label168: '50 Days',
    label169: '80 Days',
    label170: '100 Days',
    label171: '160 Days',
    label172: 'Deposited',
    label173: ' Currency',
    label174: 'No data',
    label175: 'Account',
    label176: 'Bill Month',
    label177: 'Currency',
    label178: 'Deposit term',
    label179: 'Please select the deposit currency',
    label180: 'Please select the deposit period',
    label181: 'Please select the deposit account',
    label182: 'Amount cannot be empty',
    label183: 'Please enter the correct amount',
    label184: 'Please agree to the terms',
    label185: 'Income account',
    label186: 'Withdraw to ',
    label187: 'Please select a contract account',
    label188: 'Expected Return',
    label189: 'Please select dividend frequency',
    label190: 'Please enter the retained amount',
    label191: 'Withdrawal amount',
    label192: 'Please enter the withdrawal amount',
    label193: 'Deposit can be withdrawn',
    label194: 'Withdraw All',
    label195: 'Please enter the contribution amount',
    label196: 'Please select the contribution account',
    label197: 'Contribution amount cannot be empty',
    label198: 'Contribution account cannot be empty',
    label199: 'Contribution amount cannot be less than {0}',
    label200: 'You don\'t have any account in that currency',
    label201: 'No More Data',
    label202: 'Principal Rollover',
    label203: 'Principal and Interest Rollover',
    label204: 'Transfer back to purchase account',
    label205: ' year',
    label206: ' month',
    label207: ' day',
    label208: ' years',
    label209: ' months',
    label210: ' days',
    label211: 'You don\'t have any account in this currency, the account will be automatically switched for you',
    label212: 'You don\'t have any account',
    label213: ', understand and agree to them.',
    label214: 'agreements',
    label215: 'Congratulations on completing your purchase of MONTHLY UP Product. If you have bound the following services, you can go to any branch of our bank to receive a stationery gift certificate worth MOP100 on a first-come, first-served basis while stocks last.\n' +
      'Services include: credit card/credit card automatic repayment/bank-securities/insurance/CEM automatic payment/tax automatic transfer/cash sharing automatic entry.',
    label216: 'My purchases',
    label217: 'Interest rate table for this event',

    label218: 'Deposit Tenor:',
    label219: 'Deposit Currency: ',
    label220: 'Initial Deposit Amount: ',
    label221: 'Interest Calculation Rule: Calculating interest according to the deposit period',
    label222: 'Interest Rate:',
    label223: 'Deposit Tenor',
    label224: 'to',
    label225: 'After {0} Days',
    label226: 'Arrangement After Maturity',
    label227: 'Annual Interest Rate:',
    label228: 'The maximum purchase amount is ',
    label229: ''
  },
  title: {
    title0: 'Product Classification',
    title1: 'Smart Deposit Products',
    title2: 'My',
    title3: 'Deposit information details',
    title4: 'Transaction records',
    title5: 'MONTHLY UP Deposit',
    title6: 'Information Entry',
    title7: 'transaction Result',
    title8: 'Withdrawal result',
    title9: 'Information Confirmation',
    title10: 'Demand Deposit',
    title11: 'Time Deposit',
    title12: 'DAY DAY GOLD Deposit',
    title13: 'Monthly Deposit Product',
    title14: 'withdrawal of {0}',
    title15: 'Cancellation of {0}',
    title16: '',
    title17: '',
    title18: '',
    title19: ''
  },
  argument: {
    // 月月高
    argument1: '1.The interest for the 「3+2+1Monthly Up Deposit」will be calculated on the basis of 3 phases: ',
    argument2: '2.The interest for the 「5+5+2Monthly Up Deposit」 will be calculated on the basis of 3 phases: ',
    argument3: '3.Early withdrawal after the expiration of each phase, the customer can withdraw the interest and principal of the full phase; If the withdrawal is made before the phase maturity, the deposit interest of the phase will not be issued.',
    argument4: '4.The calculation of the above interest rate for reference only. The bank\'s record of the balance and related information in the account shall be conclusive.',
    argument5: '5.The promotion period is limited, while the quota is full.',
    argument6: '6.Well Link Bank Co., Ltd. reserves the rights of all terms and conditions without prior notice.',
    argument7: '7.The above promotion is subject to terms and conditions. In case of any dispute, Well Link Bank reserves the right to final review, terminate and explain the above promotion.',
    argument8: '8.If there is any conflict or inconsistency between the Chinese and English versions, the Chinese version shall prevail.',
    argument50: '1) Phase 1 refers to the first 3-month from the date of flexible deposit placement. Phase 2 refers to the period between the fourth and fifth month (from the date of flexible deposit placement). Phase 3 refers to the period between the sixth month and the maturity date of the flexible Deposit.',
    argument51: '2) The principal and interest will be credited to the customer\'s original debit account on the 6-month maturity date.',
    argument52: '1) Phase 1 refers to the first 5-month from the date of flexible deposit placement. Phase 2 refers to the period between the sixth and tenth month (from the date of flexible deposit placement). Phase 3 refers to the period between the eleventh and the twelfth month.  ',
    argument53: '2) The principal and interest will be credited to the customer\'s original debit account on the 12-month maturity date.',
    argument54: '',
    argument55: '',
    argument56: '',
    argument57: '',
    argument58: '',
    // 天天利
    argument9: '1.The interest for the 「100+50+10 Day Day Gold Deposit」will be calculated on the basis of 3 phases: 1) Phase 1 refers to the first 100-day from the date of Interest Earned Daily Deposit placement. Phase 2 refers to the period between the 101st and 150th days (from the date of Interest Earned Daily Deposit placement). Phase 3 refers to the period between the 151st days and the maturity date of the Interest Earned Daily Deposit. 2) The interest will be pay every 50 days.',
    argument10: '2.The interest for the  「60+30+10 Day Day Gold Deposit」 will be calculated on the basis of 3 phases: 1) Phase 1 refers to the first 60-day from the date of Interest Earned Daily Deposit placement. Phase 2 refers to the period between the 61st and 90th days (from the date of Interest Earned Daily Deposit placement). Phase 3 refers to the period between the 91st days and the maturity date of the Interest Earned Daily Deposit. 2) The interest will be paid every 30 days.',
    argument11: '3.The interest for the 「30+15+5 Day Day Gold Deposit」 will be calculated on the basis of 3 phases: 1) Phase 1 refers to the first 30-day from the date of Interest Earned Daily Deposit placement. Phase 2 refers to the period between the 31st and 45th days (from the date of Interest Earned Daily Deposit placement). Phase 3 refers to the period between the 46th days and the maturity date of the Interest Earned Daily Deposit. 2) The interest will be pay every 15 days.',
    argument12: '4.The interest will be credited to the eligible customers\' original payment accounts on the next banking business day after the payable date. When withdrawn the principal early, the interest will be credited to the eligible customers\' original debit account on the same time.',
    argument13: '5.The calculation of the above interest rate for reference only. The bank\'s record of the balance and related information in the account shall be conclusive.',
    argument14: '6.The customer\'s initial deposit amount is the equivalent of MOP 100, and the upper limit is the equivalent of MOP 1 million.',
    argument15: '7.The promotion period is limited, while the quota is full.',
    argument16: '8.Well Link Bank Co., Ltd. reserves the rights of all terms and conditions without prior notice.',
    argument17: '9.The above promotion is subject to terms and conditions. In case of any dispute, Well Link Bank reserves the right to final review, terminate and explain the above promotion.',
    argument18: '10.If there is any conflict or inconsistency between the Chinese and English versions, the Chinese version shall prevail.',
    // 定期
    argument19: '1.The principal and interest will be automatically deposited into the original deduction account on the deposit maturity date.',
    argument20: '2.The promotion period is limited, while the quota is full.',
    argument21: '3.Well Link Bank Co., Ltd. reserves the rights of all terms and conditions without prior notice.',
    argument22: '4.The above promotion is subject to terms and conditions. In case of any dispute, Well Link Bank reserves the right to final review, terminate and explain the above promotion.',
    argument23: '5.If there is any conflict or inconsistency between the Chinese and English versions, the Chinese version shall prevail.',
    // 活期
    argument24: '1.This product is a smart deposit account that deposits funds from the saving account after deducting the agreed retention amount in accordance with the customer\'s agreement, and calculates the interest based on the average daily balance.',
    argument25: '2.At the end of each day, if the balance of the saving account is higher than the agreed retention amount of the customer, the funds after deducting the agreed retention amount from the saving account will be deposited into the smart deposit account; at the end of each day, if the retained amount of the account is lower than the agreed retention amount of the customer, the relevant amount will be deducted from the smart deposit account to make up the retained amount of the saving account. ',
    argument26: '3.Interest is deposited into the customer\'s original debit account every month.',
    argument27: '4.If you need to cancel the product, you need to go through the termination procedures.',
    argument28: '5.The calculation of the above interest rate for reference only. The bank\'s record of the balance and related information in the account shall be conclusive.',
    argument29: '6.The promotion period is limited, while the quota is full.',
    argument30: '7.Well Link Bank Co., Ltd. reserves the rights of all terms and conditions without prior notice.',
    argument31: '8.The above promotion is subject to terms and conditions. In case of any dispute, Well Link Bank reserves the right to final review, terminate and explain the above promotion.',
    argument32: '9.If there is any conflict or inconsistency between the Chinese and English versions, the Chinese version shall prevail.',
    // 月供
    argument33: '1.Monthly Contribution must be automatically transferred through our bank account;',
    argument34: '2.Customers who have purchased Monthly Contribution, can not purchase the high-interest current deposit product at the same time;',
    argument35: '3.The monthly payment will be deducted from the customer\'s designated account on the 1st of each month;',
    argument36: '4.If the customer contributes overdue, it will not affect the interest calculation of the account, and the final interest will be calculated based on the actual deposited amount;',
    argument37: '5.Canceling the Monthly Contribution account or early redemption will not receive interest;',
    argument38: '6.The annual interest rate and exchange rate will be adjusted from time to time according to changes in market conditions. Well Link Bank Co., Ltd. reserves the right to change the above interest rate and exchange rate preferences at any time;',
    argument39: '7.The customer\'s initial deposit amount is $500 in the corresponding currency, and the upper limit is $1 million in the corresponding currency;',
    argument40: '8.The promotion period is limited, while the quota is full;',
    argument41: '9.Well Link Bank Co., Ltd. reserves the rights of all terms and conditions without prior notice;',
    argument42: '10.The above promotion is subject to terms and conditions. In case of any dispute, Well Link Bank reserves the right to final review, terminate and explain the above promotion;',
    argument43: '11.If there is any conflict or inconsistency between the Chinese and English versions, the Chinese version shall prevail.'
  }
}
